import React from 'react';

export function WhyChooseUs() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Why Choose Our Apartment Building Buying Service
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            When you're ready to sell your apartment building, you need experienced buyers who understand 
            the complexities of multifamily real estate. Here's why property owners nationwide trust us 
            with their most valuable investments.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/eca8b7ff8ebb3c9959b83b2782dbd9fe.jpg"
              alt="Professional apartment building buyers - experienced real estate investment team"
              className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
            />
          </div>
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-8">Our Competitive Advantages</h3>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex-shrink-0 mr-4 flex items-center justify-center">
                  <i className="ri-award-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-lg text-gray-900 mb-2">15+ Years Market Experience</h4>
                  <p className="text-gray-600">
                    We've navigated multiple market cycles, economic downturns, and real estate booms. 
                    This experience allows us to make informed decisions quickly and provide stable, 
                    reliable service regardless of market conditions.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex-shrink-0 mr-4 flex items-center justify-center">
                  <i className="ri-database-2-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-lg text-gray-900 mb-2">Comprehensive Market Knowledge</h4>
                  <p className="text-gray-600">
                    Our team analyzes apartment building values across all major metropolitan areas. 
                    We understand local rent trends, cap rates, and market dynamics that affect property values.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex-shrink-0 mr-4 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-lg text-gray-900 mb-2">White-Glove Service</h4>
                  <p className="text-gray-600">
                    Every apartment building owner receives personalized attention from our experienced team. 
                    We handle all transaction details, coordinate with title companies, and ensure smooth closings.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 mb-16">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">What Sets Us Apart from Other Buyers</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-funds-line text-2xl text-orange-600"></i>
              </div>
              <h4 className="font-bold text-lg text-gray-900 mb-4">Strong Financial Position</h4>
              <p className="text-gray-600">
                Unlike individual investors or small companies, we maintain significant capital reserves 
                and established credit facilities. This financial strength ensures we can close on any 
                apartment building purchase, regardless of size or complexity.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-building-line text-2xl text-orange-600"></i>
              </div>
              <h4 className="font-bold text-lg text-gray-900 mb-4">Portfolio Diversification</h4>
              <p className="text-gray-600">
                We buy apartment buildings across different markets, property types, and price ranges. 
                This diversification strategy allows us to be flexible on pricing and terms while 
                maintaining consistent acquisition standards.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-time-line text-2xl text-orange-600"></i>
              </div>
              <h4 className="font-bold text-lg text-gray-900 mb-4">Proven Track Record</h4>
              <p className="text-gray-600">
                With over 2,500 apartment buildings purchased, we've demonstrated consistent ability 
                to close transactions. Our reputation in the industry speaks to our reliability and 
                professional standards.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}